import { Controller } from "stimulus"

// Ticket 754: personal-record banner. Shows briefly at the top of the screen and
// auto-dismisses after a few seconds; the close button dismisses it immediately.
export default class extends Controller {
  connect() {
    this.timeout = setTimeout(() => this.close(), 5000)
  }

  disconnect() {
    this.clear()
  }

  close() {
    this.clear()
    this.element.remove()
  }

  clear() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }
}
